/* Privado sheet-fit
   ------------------------------------------------------------------
   Mobile drawers/popups (cart, menu, …) open as a bottom sheet that is
   SHORTER than full height. The base theme only makes `.drawer__content`
   a real scroll container when the sheet has a DEFINITE height (its
   `h-full` chain needs a concrete parent height). A pure `height:auto` /
   `max-height` sheet leaves the content unbounded, so nothing scrolls and
   the touch gesture leaks to the homepage behind it.

   So: on open (and whenever the content changes — submenu opens, cart
   updates) we measure the natural content height and pin the sheet to
   `min(content, cap)` in pixels. With a concrete height the base
   `overflow-y:auto` content scrolls inside the sheet, and `overscroll-
   behavior:contain` (CSS) keeps that scroll from chaining to the page.
   Desktop (>639px) is left entirely to the theme. */
(function () {
  'use strict';

  var MQ = '(max-width: 639px)';
  var CAP_VH = 0.92;          // matches the CSS max-height cap; tall enough that
                             // the cart (heavy tabs-header + pinned totals/checkout
                             // footer) still gives its line-items real room
  var GUTTER = 40;            // breathing room at the top (px)

  function isMobile() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function isOpen(drawer) {
    return (
      drawer.hasAttribute('active') ||
      drawer.hasAttribute('open') ||
      drawer.classList.contains('active') ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  }

  function fit(drawer) {
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;

    if (!isMobile() || !isOpen(drawer)) {
      inner.style.height = '';     // hand back to the stylesheet
      return;
    }

    // The `height:auto` measure below momentarily un-bounds the inner scrollers,
    // which resets their scrollTop to 0 — that's what was yanking the cart back
    // to the top mid-scroll. Save every scroller's position and restore it after.
    var scrollers = drawer.querySelectorAll('.drawer__scrollable, .drawer__content');
    var saved = [];
    var i;
    for (i = 0; i < scrollers.length; i++) saved[i] = scrollers[i].scrollTop;

    // Measure the natural height with the pin removed.
    inner.style.height = 'auto';
    var natural = inner.scrollHeight;
    var cap = Math.round(
      Math.min(window.innerHeight * CAP_VH, window.innerHeight - GUTTER)
    );
    var target = Math.min(natural, cap) + 'px';
    inner.style.height = target;

    // Restore scroll positions (instantly — scroll-behavior is forced to auto
    // on these in CSS, so this never animates).
    for (i = 0; i < scrollers.length; i++) scrollers[i].scrollTop = saved[i];
  }

  function wire(drawer) {
    if (drawer.__pvSheetWired) return;
    drawer.__pvSheetWired = true;

    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; fit(drawer); });
    }

    // Re-fit ONLY on things that actually change the sheet's height:
    //  - the drawer opening/closing  (its own `active`/`open`/`aria-hidden`)
    //  - line items / submenu panels added or removed (childList)
    // We deliberately do NOT observe descendant `class` mutations: the theme
    // toggles reveal/scroll classes on items WHILE you scroll, and re-fitting
    // then was part of what bounced the cart to the top. We also don't watch
    // `style`, so our own height writes can't loop back in.
    var mo = new MutationObserver(schedule);
    mo.observe(drawer, {
      attributes: true,
      attributeFilter: ['active', 'open', 'aria-hidden', 'hidden'],
      childList: true,
      subtree: true
    });
  }

  function init() {
    var drawers = document.querySelectorAll('.drawer');
    for (var i = 0; i < drawers.length; i++) wire(drawers[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Header/cart sections can be re-rendered (Shopify section rendering API).
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    var drawers = document.querySelectorAll('.drawer');
    for (var i = 0; i < drawers.length; i++) {
      if (isOpen(drawers[i])) fit(drawers[i]);
    }
  });
})();
